import { Alert, AlertTitle } from '@mui/material'
import type React from 'react'

interface Props {
  hasVerifiedOrganisation: boolean
}

const OrganisationFallback: React.FC<Props> = ({ hasVerifiedOrganisation }) => {
  if (!hasVerifiedOrganisation) {
    return (
      <div>
        <Alert severity="warning">
          <AlertTitle>Verify the Organisation First</AlertTitle>
          <p>
            Please NOTE you MUST verify the organisation section first, before you can
            verify this financial section.
          </p>
        </Alert>
      </div>
    )
  }
  return (
    <div>
      <Alert severity="info">
        <AlertTitle>No Financial Data Exists Yet</AlertTitle>
        <p>No financial data has been verified yet for this applicant.</p>
        <p>
          When you are ready to use the verify panel, your answers will appear here after
          submitting them.
        </p>
      </Alert>
    </div>
  )
}

export default OrganisationFallback
